module.exports = __webpack_public_path__ + "img/void_spirit.6bcf9a94.png";